<template>
	<div v-html="$sanitize(html)"></div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {

		data() {
			return {
				html: ''
			}
		},

		computed: {
			...mapState({
				auth: state => state.app.auth
			})
		},

		methods: {
			refresh() {
				axios.get('/templates/header')
				.then(response => {
					this.html = response.data
				});
			}
		},

		mounted() {
			this.refresh()
		},

		watch: {
			auth(value, old) {
				if(value.avatar != old.avatar) {
					this.refresh()
				}
			}
		}

	}
</script>